import { render, staticRenderFns } from "./CoverGallery.vue?vue&type=template&id=6378bccf&scoped=true&"
import script from "./CoverGallery.vue?vue&type=script&lang=js&"
export * from "./CoverGallery.vue?vue&type=script&lang=js&"
import style0 from "./CoverGallery.vue?vue&type=style&index=0&id=6378bccf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378bccf",
  null
  
)

export default component.exports